const getDefaultValue = (value, defaultValue) => {
	return value || defaultValue;
};
const defaultFieldsOptimizationFilter = () => {
	return [
		"id",
		"name",
		"routing_api",
		"company_id",
		"optimization_group_id",
		"optimization_group_name",
		"global_profile",
		"total_distance",
		"total_minimum_driving_time",
		"total_minimum_time_service",
		"total_not_routed_vehicles",
		"total_routed_vehicles",
		"total_not_routed_visit_points",
		"total_routed_visit_points",
		"total_time_all_routes",
		"total_vehicles",
		"total_visit_points",
		"folder_path",
		"success",
		"status",
		"added_on",
	];
};
const defaultFieldsCompanyFilter = () => {
	return [
		"id",
		"name",
		"phone",
		"nit",
		"date_init",
		"date_end",
		"contac_persons",
		"address",
		"city",
		"country",
		"description",
		"realtionship",
		"admin_role_id",
		"total_resources",
		"added_on",
		"update_on",
		"optimizers",
		"related_type_configs",
		"unrelated_type_configs",
		"url_logo",
	];
};
const defaultFieldsDatarutasResources = () => {
	return [
		"id",
		"status_id",
		"status",
		"activity_id",
		"typology_name",
		"category_name",
		"role_id",
		"role_name",
		"alias",
		"name",
		"lastname",
		"username",
		"identification",
		"email",
		"company_name",
		"group_id",
		"visit_point_id",
		"additional_info",
		"company_id",
	];
};
const defaultFieldsOptimizeManager = () => {
	return [
		"id",
		"api_key",
		"optimization_api",
		"company_id",
		"date_end",
		"points_per_month",
		"points_per_week",
		"points_per_day",
		"points_subscription_monthly",
		"points_total",
		"web_enable",
		"api_enable",
		"resource_email_add",
		"resource_email_update",
		"added_on",
		"update_on",
		"company_name",
		"total",
		"total_last_1_day",
		"total_last_7_days",
		"total_last_month",
		"total_current_subscription",
	];
};
const addUnreadMails = (unreadMails, emailIds) => {
	emailIds.forEach((mailId) => {
		if (!unreadMails.includes(mailId)) {
			unreadMails.push(mailId);
		}
	});
};
const removeUnreadMails = (unreadMails, emailIds) => {
	emailIds.forEach((mailId) => {
		const mailIdIndex = unreadMails.indexOf(mailId);
		if (mailIdIndex !== -1) {
			unreadMails.splice(mailIdIndex, 1);
		}
	});
};
const commitVisitPoints = (commit, records, shippingType) => {
	const mutation = shippingType === "pickup" ? "SET_VISIT_POINTS_PICKUP" : "SET_VISIT_POINTS_DELIVERY";
	commit(mutation, records);
};
const commitVehicles = (commit, records, data) => {
	if (data.additionalFields) {
		return;
	}
	if (data.hasOwnProperty("assign") && data.assign) {
		commit("SET_ASSIGNED_VEHICLE", records);
	} else {
		commit("SET_VEHICLES", records);
	}
};
const processVisitPointRecords = (records) => {
	return records.map((element) => ({
		...element,
		demand: 0,
		typeService: "PICKUP",
		isEditDemand: false,
		isEditTypeService: false,
		isPickup: false,
		isDelivery: false,
	}));
};
const processVehicleRecords = (records, data) => {
	if (data.additionalFields) {
		return records;
	}
	if (data.hasOwnProperty("assign") && data.assign) {
		return records.map((element) => ({
			...element,
			demand: 0,
			isEditDemand: false,
		}));
	}
	return records;
};
const processSkillRecords = (records) => {
	return records.map((skill) => {
		const vehicleIds = skill.vehicle_id ? skill.vehicle_id.map((item) => item.vehicle_id) : [];
		const visitPointIds = skill.visit_point_id ? skill.visit_point_id.map((item) => item.visit_point_id) : [];
		return {
			...skill,
			amountVehicles: vehicleIds.length,
			amountVisitPoints: visitPointIds.length,
		};
	});
};
const processCapacity = (capacity) => {
	let vehicle_ids = capacity.vehicles ? capacity.vehicles.map((vehicle) => vehicle.vehicle_id) : [];
	let visit_points_ids = capacity.visit_points ? capacity.visit_points.map((point) => point.visit_point_id) : [];
	return {
		...capacity,
		amount: 0,
		demand: 0,
		typeService: "PICKUP",
		isEditDemand: false,
		isEditTypeService: false,
		amountVehicles: vehicle_ids.length,
		amountVisitPoints: visit_points_ids.length,
	};
};
const createVisitPointPayload = (data) => {
	return {
		page: getDefaultValue(data.page, 1),
		quantity: getDefaultValue(data.quantity, 1000000),
		fields: getDefaultValue(data.fields, []),
		id: getDefaultValue(data.id, []),
		identification: getDefaultValue(data.identification, []),
		status_id: getDefaultValue(data.status_id, []),
		city: getDefaultValue(data.city, []),
		department: getDefaultValue(data.department, []),
		country: getDefaultValue(data.country, []),
		address: getDefaultValue(data.address, []),
		priority: getDefaultValue(data.priority, []),
		time_service: getDefaultValue(data.time_service, []),
		additional_info: getDefaultValue(data.additional_info, []),
		skills_id: getDefaultValue(data.skills_id, []),
		capacities: getDefaultValue(data.capacities, []),
		time_windows_id: getDefaultValue(data.time_windows_id, []),
		repeat_frequency_id: getDefaultValue(data.repeat_frequency_id, []),
		order_by: getDefaultValue(data.order_by, ["id"]),
		sort: getDefaultValue(data.sort, "asc"),
	};
};
const createVisitPointFromShipmentsPayload = (data) => {
	return {
		page: getDefaultValue(data.page, 1),
		quantity: getDefaultValue(data.quantity, 1000000),
		fields: [
			"identification",
			"cy",
			"cx",
			"city",
			"department",
			"country",
			"address",
			"time_service",
			"priority",
			"status_id",
			"status_name",
			"additional_info",
			"json_properties",
			"capacities",
			"skill_id",
			"time_window_id",
			"repeat_frequency_id",
		],
		id: getDefaultValue(data.id, []),
		identification: getDefaultValue(data.identification, []),
		status_id: getDefaultValue(data.status_id, []),
		city: getDefaultValue(data.city, []),
		department: getDefaultValue(data.department, []),
		country: getDefaultValue(data.country, []),
		address: getDefaultValue(data.address, []),
		priority: getDefaultValue(data.priority, []),
		time_service: getDefaultValue(data.time_service, []),
		additional_info: getDefaultValue(data.additional_info, []),
		skills_id: getDefaultValue(data.skills_id, []),
		capacities: getDefaultValue(data.capacities, []),
		time_windows_id: getDefaultValue(data.time_windows_id, []),
		repeat_frequency_id: getDefaultValue(data.repeat_frequency_id, []),
		order_by: getDefaultValue(data.order_by, ["id"]),
		sort: getDefaultValue(data.sort, "asc"),
	};
};
const createVisitPointPaginatedPayload = (data) => {
	return {
		page: getDefaultValue(data.page, 1),
		quantity: getDefaultValue(data.quantity, 1000000),
		fields: [
			"identification",
			"cy",
			"cx",
			"city",
			"department",
			"country",
			"address",
			"time_service",
			"priority",
			"status_id",
			"status_name",
			"additional_info",
			"json_properties",
			"capacities",
			"skill_id",
			"time_window_id",
			"repeat_frequency_id",
		],
		id: getDefaultValue(data.id, []),
		identification: getDefaultValue(data.identification, []),
		status_id: getDefaultValue(data.status_id, []),
		city: getDefaultValue(data.city, []),
		department: getDefaultValue(data.department, []),
		country: getDefaultValue(data.country, []),
		address: getDefaultValue(data.address, []),
		priority: getDefaultValue(data.priority, []),
		time_service: getDefaultValue(data.time_service, []),
		additional_info: getDefaultValue(data.additional_info, []),
		skills_id: getDefaultValue(data.skills_id, []),
		capacities: getDefaultValue(data.capacities, []),
		time_windows_id: getDefaultValue(data.time_windows_id, []),
		repeat_frequency_id: getDefaultValue(data.repeat_frequency_id, []),
		match_filter: data.match_filter,
		order_by: getDefaultValue(data.order_by, ["id"]),
		sort: getDefaultValue(data.sort, "asc"),
	};
};
const createDatarutasResourcePayload = (data) => {
	return {
		page: getDefaultValue(data.page, 1),
		quantity: getDefaultValue(data.quantity, 1000000),
		fields: getDefaultValue(data.fields, defaultFieldsDatarutasResources()),
		id: getDefaultValue(data.id, []),
		status_id: getDefaultValue(data.status_id, []),
		status: getDefaultValue(data.status, []),
		activity_id: getDefaultValue(data.activity_id, []),
		typology_name: getDefaultValue(data.typology_name, []),
		category_name: getDefaultValue(data.category_name, []),
		event_id: getDefaultValue(data.event_id, []),
		role_id: getDefaultValue(data.role_id, []),
		role_name: getDefaultValue(data.role_name, []),
		alias: getDefaultValue(data.alias, []),
		name: getDefaultValue(data.name, []),
		lastname: getDefaultValue(data.lastname, []),
		username: getDefaultValue(data.username, []),
		identification: getDefaultValue(data.identification, []),
		email: getDefaultValue(data.email, []),
		company_name: getDefaultValue(data.company_name, []),
		group_id: getDefaultValue(data.group_id, []),
		visit_point_id: getDefaultValue(data.visit_point_id, []),
		additional_info: getDefaultValue(data.additional_info, []),
		company_id: getDefaultValue(data.company_id, []),
		order_by: "id",
		sort: "DESC",
	};
};
const createVehiclePaginatedPayload = (data) => {
	return {
		page: getDefaultValue(data.page, 1),
		quantity: getDefaultValue(data.quantity, 1000000),
		fields: [
			"id",
			"identification",
			"profile",
			"max_travel_distance",
			"max_travel_duration",
			"init_depot_id",
			"init_depot_name",
			"end_depot_id",
			"end_depot_name",
			"costs",
			"json_properties",
			"additional_info",
			"team_id",
			"break_id",
			"skill_id",
			"repeat_frequency_id",
			"capacities",
		],
		id: getDefaultValue(data.id, []),
		identification: getDefaultValue(data.identification, []),
		profile: getDefaultValue(data.profile, []),
		max_travel_distance: getDefaultValue(data.max_travel_distance, []),
		max_travel_duration: getDefaultValue(data.max_travel_duration, []),
		init_depot_id: getDefaultValue(data.init_depot_id, []),
		end_depot_id: getDefaultValue(data.end_depot_id, []),
		additional_info: getDefaultValue(data.additional_info, []),
		costs: getDefaultValue(data.costs, []),
		company_name: getDefaultValue(data.company_name, []),
		init_depot_name: getDefaultValue(data.init_depot_name, []),
		end_depot_name: getDefaultValue(data.end_depot_name, []),
		skill_id: getDefaultValue(data.skill_id, []),
		break_id: getDefaultValue(data.break_id, []),
		repeat_frequency_id: getDefaultValue(data.repeat_frequency_id, []),
		team_id: getDefaultValue(data.team_id, []),
		capacities: getDefaultValue(data.capacities, []),
		match_filter: data.match_filter,
		order_by: getDefaultValue(data.order_by, ["id"]),
		sort: getDefaultValue(data.sort, "asc"),
	};
};
const createSkillPayload = (data) => {
	return {
		page: getDefaultValue(data.page, 1),
		quantity: getDefaultValue(data.quantity, 1000000),
		fields: getDefaultValue(data.fields, [
			"id",
			"name",
			"description",
			"vehicle_id",
			"visit_point_id",
			"company_id",
			"added_on",
			"update_on",
		]),
		id: getDefaultValue(data.id, []),
		name: getDefaultValue(data.name, []),
		description: getDefaultValue(data.description, []),
		vehicle_id: getDefaultValue(data.vehicle_id, []),
		visit_point_id: getDefaultValue(data.visit_point_id, []),
		match_filter: data.match_filter,
		order_by: getDefaultValue(data.order_by, ["name"]),
		sort: getDefaultValue(data.sort, "asc"),
	};
};
const createOptimizerManagerPayload = (data) => {
	// Fields that require default values
	const defaultFields = [
		"page",
		"quantity",
		"fields",
		"id",
		"api_key",
		"optimization_api",
		"company_id",
		"date_end",
		"points_per_month",
		"points_per_week",
		"points_per_day",
		"points_subscription_monthly",
		"points_total",
		"web_enable",
		"api_enable",
		"resource_email_add",
		"resource_email_update",
		"added_on",
		"update_on",
		"company_name",
		"order_by",
		"sort",
	];
	// Map over default fields and apply getDefaultValue
	const payload = defaultFields.reduce((acc, field) => {
		let fieldValue =
			{
				fields: defaultFieldsOptimizeManager() || [],
				order_by: ["id"],
				page: 1,
				quantity: 1000000,
				sort: "asc",
			}[field] || [];
		acc[field] = getDefaultValue(data[field] || fieldValue);
		return acc;
	}, {});
	// Add specific fields that are not part of the default fields
	return {
		...payload,
		match_filter: data.match_filter,
	};
};
const createOptimizationFilter = (data) => {
	return {
		page: getDefaultValue(data.page, 1),
		quantity: getDefaultValue(data.quantity, 1000000),
		fields: getDefaultValue(data.fields, defaultFieldsOptimizationFilter()),
		id: getDefaultValue(data.id, []),
		name: getDefaultValue(data.name, []),
		routing_api: getDefaultValue(data.routing_api, []),
		optimization_group_id: getDefaultValue(data.optimization_group_id, []),
		optimization_group_name: getDefaultValue(data.optimization_group_name, []),
		global_profile: getDefaultValue(data.global_profile, []),
		total_distance: getDefaultValue(data.total_distance, []),
		total_minimum_driving_time: getDefaultValue(data.total_minimum_driving_time, []),
		total_minimum_time_service: getDefaultValue(data.total_minimum_time_service, []),
		total_not_routed_vehicles: getDefaultValue(data.total_not_routed_vehicles, []),
		total_routed_vehicles: getDefaultValue(data.total_routed_vehicles, []),
		total_not_routed_visit_points: getDefaultValue(data.total_not_routed_visit_points, []),
		total_routed_visit_points: getDefaultValue(data.total_routed_visit_points, []),
		total_time_all_routes: getDefaultValue(data.total_time_all_routes, []),
		total_vehicles: getDefaultValue(data.total_vehicles, []),
		total_visit_points: getDefaultValue(data.total_visit_points, []),
		folder_path: getDefaultValue(data.folder_path, []),
		success: getDefaultValue(data.success, []),
		status: getDefaultValue(data.status, []),
		match_filter: data.match_filter,
		order_by: getDefaultValue(data.order_by, ["id"]),
		sort: getDefaultValue(data.sort, "asc"),
	};
};
const createCompanyFilterPayload = (data) => {
	const defaultFields = [
		"page",
		"quantity",
		"fields",
		"id",
		"name",
		"phone",
		"nit",
		"date_init",
		"date_end",
		"contac_persons",
		"address",
		"city",
		"country",
		"description",
		"realtionship",
		"admin_role_id",
		"total_resources",
		"added_on",
		"update_on",
		"optimizers",
		"related_type_configs",
		"unrelated_type_configs",
		"order_by",
		"sort",
	];
	const payload = defaultFields.reduce((acc, field) => {
		let fieldValue =
			{
				fields: defaultFieldsCompanyFilter(),
				order_by: ["name"],
				page: 1,
				quantity: 1000000,
				sort: "desc",
			}[field] || [];
		acc[field] = getDefaultValue(data[field] || fieldValue);
		return acc;
	}, {});
	return {
		...payload,
		match_filter: data.match_filter,
	};
};
const createCapacityFilter = (data) => {
	return {
		page: getDefaultValue(data.page || 1),
		quantity: getDefaultValue(data.quantity || 1000000),
		fields: ["id", "name", "description", "visit_points", "vehicles", "company_id", "added_on", "update_on"],
		id: getDefaultValue(data.id || []),
		name: getDefaultValue(data.name || []),
		description: getDefaultValue(data.description || []),
		visit_points: getDefaultValue(data.visit_points || []),
		vehicles: getDefaultValue(data.vehicles || []),
		match_filter: data.match_filter,
		order_by: getDefaultValue(data.order_by || ["id"]),
		sort: getDefaultValue(data.sort || "asc"),
	};
};
export {
	commitVisitPoints,
	commitVehicles,
	processVisitPointRecords,
	processVehicleRecords,
	processSkillRecords,
	processCapacity,
	createVisitPointPayload,
	createVisitPointFromShipmentsPayload,
	createVisitPointPaginatedPayload,
	createDatarutasResourcePayload,
	createVehiclePaginatedPayload,
	createSkillPayload,
	createOptimizerManagerPayload,
	createOptimizationFilter,
	createCompanyFilterPayload,
	createCapacityFilter,
	addUnreadMails,
	removeUnreadMails,
};
